module.exports = __webpack_public_path__ + "img/from_toeicBTest_content03.9b022cab.svg";